import Vue from 'vue';

export default function (to) {
    if(to.meta.membership !== undefined){
        if(to.meta.membership){
            if(!Vue.auth.check() || !Vue.auth.user().membership_active){
                return Vue.router.push({name: '404'});
            }
        }
        //// ahora, incluso si es membership_active, puede entrar para comprar otra suscripción
        // else{
        //     if(Vue.auth.check() && Vue.auth.user().membership_active){
        //         return Vue.router.push({name: 'home'});
        //     }
        // }
    }
}